import { Benefit } from "./benefit";
import { BenefitDivisionArea } from "./benefit-division-area";


export class BenefitConfiguration {

    id: number = 0;
    benefit: Benefit = new Benefit();
    description!: string;
    formula!: string;
    active: boolean = false;

    benefitDivisionAreaList: BenefitDivisionArea[] = [];
    
}